import { render, staticRenderFns } from "./confirmacion.vue?vue&type=template&id=54311800&scoped=true&"
import script from "./confirmacion.vue?vue&type=script&lang=js&"
export * from "./confirmacion.vue?vue&type=script&lang=js&"
import style0 from "./confirmacion.vue?vue&type=style&index=0&id=54311800&lang=scss&scoped=true&"
import style1 from "./confirmacion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54311800",
  null
  
)

export default component.exports